import { ActionType, getType } from 'typesafe-actions';
import { IReservationStore } from '../../interfaces';
import * as actions from './reservation-actions';

const initialState: IReservationStore = {
    datetime: {
        participants: 0,
        date: '',
        dateOption: '',
        shiftTime: '',
        time: '',
        showAllTimes: false,
        areaId: '',
        shiftId: '',
    },
    person: {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        comment: '',
        allergies: '',
        subscribeToNewsletter: false,
        company: '',
        sendEmailReminder: true,
        sendSmsReminder: false,
    },
    bookingResponse: undefined,
    isLoading: false,
    hasError: false,
    error: {},
};

// eslint-disable-next-line
export default function reservationReducer(
    state: IReservationStore = initialState,
    action: ActionType<typeof actions>,
) {
    switch (action.type) {
        case getType(actions.saveReservationDateTime):
            return { ...state, datetime: action.payload.datetime };
        case getType(actions.saveReservationPerson):
            return { ...state, person: action.payload.person };
        case getType(actions.saveReservationRequested):
            return { ...state, isLoading: true, hasError: false };
        case getType(actions.saveReservationSucceeded):
            return { ...state, isLoading: false, hasError: false, bookingResponse: action.payload };
        case getType(actions.saveReservationFailed):
            return { ...state, isLoading: false, hasError: true, error: action.payload };
        case getType(actions.resetError):
            return {
                ...state,
                hasError: false,
            };
        default:
            return state;
    }
}
